import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';

export const rpcClient = createRpcClientV2({ hubHttpClient: http });
